import { render, staticRenderFns } from "./registroemail-form.vue?vue&type=template&id=334bf098&scoped=true"
import script from "./registroemail-form.vue?vue&type=script&lang=js"
export * from "./registroemail-form.vue?vue&type=script&lang=js"
import style0 from "./registroemail-form.vue?vue&type=style&index=0&id=334bf098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334bf098",
  null
  
)

export default component.exports